import CheckoutComponent from "@components/CheckoutPage/CheckoutComponent"
import styles from "./CheckoutPage.module.css"
const CheckoutPage = () => {
    return (
        <div className={styles.Wrapper}>
            <CheckoutComponent />
        </div>
    )
}

export default CheckoutPage
